export const MIME_TYPE: Record<
  string,
  {
    id: string
    type: string
  }
> = {
  docx: {
    id: 'docx',
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  },
  pdf: {
    id: 'pdf',
    type: 'application/pdf'
  },
  jpeg: {
    id: 'jpeg',
    type: 'image/jpeg'
  },
  png: {
    id: 'png',
    type: 'image/png'
  },
  jpg: {
    id: 'jpg',
    type: 'image/jpeg'
  }
}
